import { md, Node } from 'djedi-react'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import classnames from 'classnames'

import Page from 'layouts/Page'
import Container from 'layouts/Container'
import Distribute from 'layouts/Distribute'
import Box, { BoxSection } from 'layouts/Box'
import Search from 'components/Search'
import Button from 'components/Button'
import StoryCarousel from 'components/StoryCarousel'
import BreakitBanner from 'components/BreakitBanner'

import api from 'api'
import { reverse } from 'utilities/routes'
import { NAME as ROUTE_FIND } from 'views/FindActivity/constants'

import leaderLydia from 'assets/homepage/student-lydia.jpg'
import leaderEmil from 'assets/homepage/student-emil.jpg'
import leaderLeonie from 'assets/homepage/student-leonie.jpg'
import leaderSara from 'assets/homepage/student-sara.jpg'

import parentKarin from 'assets/homepage/foralder-karin-stockholm.jpg'
import parentMalin from 'assets/homepage/foralder-malin-stockholm.jpg'
import parentSusanne from 'assets/homepage/foralder-susanne-stockholm.jpg'

import Link from 'components/Link'
import { NAME as ROUTE_ACTIVITIES_AND_SCHOOLS } from 'views/ActivitiesAndSchools/constants'
import styles from './styles.css'

class HomePage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  }

  onSearch(tags) {
    const { dispatch } = this.props
    dispatch(
      reverse(ROUTE_FIND, {
        query: { tag: tags.length > 0 ? tags[0].name : undefined },
      }),
    )
  }

  async suggest(input) {
    return api.search.suggest(input)
  }

  render() {
    //
    return (
      <Page
        // {...this.props.meta.toJS()}
        className={styles.root}
        description="Jag vill tipsa om friendtivity om du letar fritidsaktiviteter för dina barn. Gå in på friendtivity.se"
      >
        <div className={styles.hero}>
          <div className={styles.heroContainer}>
            <h1 className={styles.heroTitle}>
              <Node uri="home/hero/title">
                Hitta roliga och utvecklande fritidsaktiviteter!
              </Node>
            </h1>

            <p className={styles.heroPreamble}>
              <Node uri="home/hero/preamble">
                Vi erbjuder fritidsaktiviteter på ett nytt sätt - i små grupper
                i hemmet med en av våra anställda ledare. Låt ditt barn
                utvecklas och inspireras att lära mer kring t.ex. ett skolämne
                eller varför inte upptäcka ett nytt intresse som t.ex.
                programmering, språk, schack, teater, bakning eller något helt
                annat. Aktiviteterna kan ske efter skolan, på helgen, eller
                loven med nya och gamla kompisar.
              </Node>
            </p>

            <form
              method="post"
              onSubmit={e => {
                e.preventDefault()
                this.onSearch([])
              }}
              className={styles.search}
            >
              <Search
                className={styles.searchInput}
                suggestions={this.suggest.bind(this)}
                placeholder="Skriv in den aktivitet/det intresse du letar efter"
                onChange={this.onSearch.bind(this)}
                keyFunc={x => x.id}
              />

              <Button className={styles.searchButton}>Sök</Button>
            </form>

            <div style={{ textAlign: 'center' }}>
              <Link
                label="Se alla aktiviteter"
                href={reverse(ROUTE_ACTIVITIES_AND_SCHOOLS)}
                exceptRole="hoppsan"
                className={styles.link}
              />
            </div>

          </div>
        </div>

        <div className={styles.boxes}>
          <Container size="large">
            <h2>
              <Node uri="home/heading1">
                Marknadens schysstaste pris (fr. 95 kr/tim per deltagare) med
                nöjdhetsgaranti
              </Node>
            </h2>
            <Distribute equalHeight>
              <Box shadow>
                <BoxSection>
                  <div className={classnames(styles.uspIcon, styles.green)}>
                    <FontAwesomeIcon icon={['far', 'life-ring']}/>
                  </div>
                  <Node uri="home/pitch-box-1.md">
                    {md`
                      ###Ett unikt utbud där alla kan hitta sin aktivitet och sitt sammanhang

                      Våra ledare har olika intressen och kompetenser i allt från skolämnen,
                      musik, språk programmering till bakning, teater och schack.
                      Hitta en aktivitet som passar just ditt barn kring ett intresse,
                      eller varför inte kombinera två? T.ex. baka på engelska eller
                      ha matte och schack under samma tillfälle.
                    `}
                  </Node>
                </BoxSection>
              </Box>

              <Box shadow>
                <BoxSection>
                  <div className={classnames(styles.uspIcon, styles.blue)}>
                    <FontAwesomeIcon icon={['far', 'heart']}/>
                  </div>
                  <Node uri="home/pitch-box-2.md">
                    {md`
                      ###Tryggt och säkert

                      Våra ledare är anställda av Friendtivity AB
                      och har alla passerat en gedigen rekryteringsprocess.
                      Givetvis har vi nöjdhetsgaranti vilket innebär att
                      du får tillbaka dina pengar efter första tillfället
                      ifall du av någon anledning inte är nöjd.
                    `}
                  </Node>
                </BoxSection>
              </Box>

              <Box shadow>
                <BoxSection>
                  <div className={classnames(styles.uspIcon, styles.orange)}>
                    <FontAwesomeIcon icon={['far', 'calendar-check']}/>
                  </div>
                  <Node uri="home/pitch-box-3.md">
                    {md`
                      ###Flexibelt och hämtning ingår

                      Du skapar din egen grupp och bestämmer
                      själv var, när och hur länge aktiviteten
                      ska pågå och vilka som är med. Självklart
                      hämtar våra ledare era barn vid skolan
                      om ni vill. Vill du ha en aktivitet enbart
                      för ditt barn så går det lika bra.
                    `}
                  </Node>
                </BoxSection>
              </Box>
            </Distribute>
            <p className={styles.spacer}>
              <Button rounded onClick={() => this.onSearch([])}>
                Sök
              </Button>
            </p>
          </Container>
        </div>
        <div className={styles.storyWrapper}>
          <Container size="medium">
            <h2>
              <Node uri="home/heading2">
                Läs vad andra föräldrar säger om friendtivity
              </Node>
            </h2>
            <StoryCarousel
              stories={[
                {
                  picture: parentSusanne,
                  story: (
                    <Node uri="home/stories/parent1.md">
                      {md`
                        Nu behöver jag inte stressa till hämtning, utan med friendtivity
                        så kan mitt barn och ett par av deras kompisar bli hämtade direkt från
                        skolan och få tillbringa eftermiddagen på ett meningsfullt sätt genom att
                        i ett avslappnat format lära sig tex gitarr, schack, bakning med en härlig
                        och duktig friendtivity ledare. Och kanske även ha aktiviteten på ett nytt språk.

                        Susanne, Stockholm
                      `}
                    </Node>
                  ),
                },
                {
                  picture: parentKarin,
                  story: (
                    <Node uri="home/stories/parent2.md">
                      {md`
                        Jag ser fram emot att kunna hitta bra fritidsaktivieter för mina barn i vårt närområde
                        utan att behöva planera jättelång tid i förväg. Kul att t.ex. kunna prova en 4 veckors
                        aktivitet mitt i terminen.

                        Karin, Stockholm
                      `}
                    </Node>
                  ),
                },
                {
                  picture: parentMalin,
                  story: (
                    <Node uri="home/stories/parent3.md">
                      {md`
                        Spännande nytt koncept som öppnar upp möjligheter att delta i fritidsaktiviteter
                        som verkligen passar mitt barn. Att aktiviteterna sker i hemmet i en liten grupp om max
                        fyra känns också tryggt och bra.

                        Malin, Stockholm
                      `}
                    </Node>
                  ),
                },
              ]}
            />
          </Container>
        </div>
        <div className={styles.boxes}>
          <Container size="large">
            <h2>
              <Node uri="home/heading3">Möt några av våra ledare</Node>
            </h2>

            <Distribute equalHeight>
              <Box shadow>
                <BoxSection className={styles.compactBox}>
                  <div className={styles.imageWrapper}>
                    <img src={leaderLydia} className={styles.boxImage} alt=""/>
                  </div>
                  <Node uri="home/leader-boxes/person1.md">
                    {md`
                      **Lydia, 20 år**

                      KTH-student (Ind. ek.) och fantastisk fotograf
                    `}
                  </Node>
                </BoxSection>
              </Box>

              <Box shadow>
                <BoxSection className={styles.compactBox}>
                  <div className={styles.imageWrapper}>
                    <img src={leaderEmil} className={styles.boxImage} alt=""/>
                  </div>
                  <Node uri="home/leader-boxes/person2.md">
                    {md`
                      **Emil, 19 år**

                      KTH-student (Ind. ek.), med fokus på mattegrupper.
                    `}
                  </Node>
                </BoxSection>
              </Box>

              <Box shadow>
                <BoxSection className={styles.compactBox}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={leaderLeonie}
                      className={styles.boxImage}
                      alt=""
                    />
                  </div>
                  <Node uri="home/leader-boxes/person3.md">
                    {md`
                      **Leonie, 21 år**

                      Södertörns Högskola, tysktalande med fokus på kreativt skapande.
                    `}
                  </Node>
                </BoxSection>
              </Box>

              <Box shadow>
                <BoxSection className={styles.compactBox}>
                  <div className={styles.imageWrapper}>
                    <img src={leaderSara} className={styles.boxImage} alt=""/>
                  </div>
                  <Node uri="home/leader-boxes/person4.md">
                    {md`
                      **Sara, 23 år**

                      KTH-student med fokus på kreativa grupper inom programmering och matte.
                    `}
                  </Node>
                </BoxSection>
              </Box>
            </Distribute>
          </Container>
        </div>
        <BreakitBanner/>
      </Page>
    )
  }
}

export default connect()(HomePage)



// WEBPACK FOOTER //
// ../source/views/Home/index.js